import { render } from "./MenuActiveStyle.vue?vue&type=template&id=4656c451"
import script from "./MenuActiveStyle.vue?vue&type=script&lang=js"
export * from "./MenuActiveStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__